import { ReactNode } from 'react'
import PageMasthead from '../components/PageMasthead'
import { useTitle } from '../components/TitleProvider'

interface AccountOnboardingLayoutProps {
    title: string
    /** Browser-tab text, when it should differ from the visible masthead title. */
    tabTitle?: string
    subtitle?: string
    actions?: ReactNode
    children: ReactNode
}

/**
 * Page shell for the account-add flow — account/new and the per-platform
 * onboarding pages. Mirrors HomePage: the shared PageMasthead (Jost title with
 * the arwen dot) over a full-width ink-50 body, so the header and theme stay
 * identical from the profile list right through adding a profile.
 *
 * This deliberately replaces the TextPageContainer + TextPageHeader pairing on
 * the onboarding pages only. TextPageContainer/TextPageHeader stay in place for
 * the many other text pages that still use them, so this change is scoped to the
 * account flow.
 */
export function AccountOnboardingLayout({
    title,
    tabTitle,
    subtitle,
    actions,
    children
}: AccountOnboardingLayoutProps) {
    useTitle(tabTitle || title)
    return (
        <div className="min-h-full bg-ink-50">
            <PageMasthead title={title} subtitle={subtitle} actions={actions} />
            <div className="px-4 py-5 sm:px-6 lg:px-8">
                {/* Page content sits in a centred white card, matching the feeds and
                    profiles cards on the home page so the whole account area reads as
                    one system. */}
                <div className="mx-auto max-w-4xl rounded-lg border border-ink-200 bg-white p-6 shadow-sm sm:p-8">
                    {children}
                </div>
            </div>
        </div>
    )
}
